import React from 'react'
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'

class Term extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    if (!this.props.disableInit) {
      this.terminal = new Terminal({
        fontSize: window.innerWidth <= 1400 ? 12 : 14,
        theme: {
          background: this.props.background || undefined
        }
      })
      this.fitAddon = new FitAddon()
      this.terminal.open(document.getElementById(this.props.id || 'terminal'))
      this.terminal.loadAddon(this.fitAddon)
      this.fitAddon.fit()
    }
  }

  getTerminal() {
    return this.terminal
  }

  init(callback) {
    this.terminal = new Terminal({
      fontSize: window.innerWidth <= 1400 ? 12 : 14,
      theme: {
        background: this.props.background || undefined
      }
    })
    this.fitAddon = new FitAddon()
    this.terminal.open(document.getElementById(this.props.id || 'terminal'))
    this.terminal.loadAddon(this.fitAddon)
    this.fitAddon.fit()
    if (callback) callback()
  }

  fit() {
    this.fitAddon.fit()
  }

  render() {
    return (
      <>
        <div style={this.props.style || { height: '100%', minHeight: 100 }} className={typeof this.props.className === 'string' ? this.props.className : 'uk-height-medium'} id={this.props.id || 'terminal'} />
      </>
    )
  }
}

export default Term
